var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.793 3.793a1 1 0 1 1 1.414 1.414L5.914 7.5H15.5a7 7 0 0 1 0 14h-4a1 1 0 0 1 0-2h4a5 5 0 0 0 0-10H5.914l2.293 2.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1-.092-.109l-.033-.044a1 1 0 0 1-.125-.263l-.013-.05a1 1 0 0 1-.003-.473l.016-.061a1 1 0 0 1 .122-.257q.056-.086.128-.157z"
  })));
};
export default Svg24;